require("!!/root/xmpp-web/node_modules/script-loader/addScript.js")(require("!!/root/xmpp-web/node_modules/script-loader/node_modules/raw-loader/index.js!/root/xmpp-web/node_modules/strophejs-plugins/rsm/strophe.rsm.js"))


/*****************
 ** WEBPACK FOOTER
 ** ./~/script-loader!./~/strophejs-plugins/rsm/strophe.rsm.js
 ** module id = 11
 ** module chunks = 0
 **/